"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callback = void 0;
const subject_def_1 = require("./subject-def");
const callback = (target, propertyKey) => {
    subject_def_1.ClassSubjectDef
        .getOrMakeFor(target.constructor)
        .addCallback(propertyKey);
};
exports.callback = callback;
//# sourceMappingURL=callback.js.map